export default __webpack_public_path__ + "static/media/webgpu-img.7ee8f0e4.svg";